import { render, staticRenderFns } from "./dlconProfile.vue?vue&type=template&id=4d86d3d8&scoped=true&"
import script from "./dlconProfile.vue?vue&type=script&lang=js&"
export * from "./dlconProfile.vue?vue&type=script&lang=js&"
import style0 from "./dlconProfile.vue?vue&type=style&index=0&id=4d86d3d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d86d3d8",
  null
  
)

export default component.exports